import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-valethome',
    templateUrl: './valethome.component.html',
    styleUrls: ['./valethome.component.scss'],
    standalone: false
})
export class ValetHomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
}
